// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3969":"241f7cf1f1a5aa87","7456":"b6323009d4472833"}[chunkId] + ".css";
};